<ngx-slider
  [(value)]="value"
  [highValue]="highValue"
  [options]="options"
  (valueChange)="onValueChange()"
  [style.max-width.px]="width"
></ngx-slider>
